/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React from 'react';
import './bannerCTA.scss';
import Button from '@react/react-spectrum/Button';

const BannerCTA = (props) => {
    const {
        buttonItem,
        style,
        textColor,
        onAction,
        bannerAnalyticsCallback,
    } = props;
    const btnStyle = { ...style };
    let buttonVariant = buttonItem.variant && buttonItem.variant.toLowerCase();
    if (buttonVariant === 'primary') {
        btnStyle.borderColor = textColor;
    } else {
        buttonVariant = 'secondary';
    }
    return (
        <span className="banner-cta"> <Button
            label={buttonItem.label}
            role="button"
            aria-label={buttonItem.label}
            variant={buttonVariant}
            className={buttonVariant !== 'primary' ? 'quiet-action' : 'action'}
            quiet={buttonVariant !== 'primary'}
            style={{ ...btnStyle }}
            onClick={() => {
                onAction();
                bannerAnalyticsCallback();
            }} />
        </span>
    );
};
export default BannerCTA;
